import { NgModule } from '@angular/core';

import { SecondsInDaysPipe } from './seconds-in-days.pipe';

@NgModule({
  exports: [SecondsInDaysPipe],
  declarations: [SecondsInDaysPipe],
})
export class SecondsInDaysModule {}
export { SecondsInDaysPipe } from './seconds-in-days.pipe';
